import { D739_DRIVER_SIGNUP_VOCABULARIES } from './d739-driver-signup.js';
/** Slice d739 of the catalog: the provider app's own sign-up (D752 + D759 of the D751 program, doc 34; ADR-0151) - its governed rules, steps, modalities and refusals. */
export const SLICE_D739 = [...D739_DRIVER_SIGNUP_VOCABULARIES];
//# sourceMappingURL=slice-d739.js.map